import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import CustomFormulaList from "./CustomFormulaList";
import FavoriteFormulaList from "./FavoriteFormulaList";
import SearchByDiseaseList from "./SearchByDiseaseList";
import SearchByFormulaList from "./SearchByFormulaList";
import SearchByPatendedFormula from "./SearchByPatentedFormula";

const FormulaFinderPopup = ({
  closePopup,
  isRawType,
  fromCustomFormula = false,
}) => {
  const [activeSection, setActiveSection] = useState(0);
  const [includeDosage, setIncludeDosage] = useState(isRawType ? true : false);
  useEffect(() => {}, []);

  return (
    <Modal size="xl" show={true} id="prescription-popup">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-6" style={{ marginLeft: "-10px" }}>
                  <h2 className="heading">Formula Finder</h2>
                  <p className="desc">
                    Use the Formula Finder to find the herbs you need.
                  </p>
                </div>

                <div className="formula-tab">
                  <div className="row">
                    <div className="tab-wrapper">
                      <div
                        className={`tab ${
                          activeSection === 0 ? "selected" : ""
                        }`}
                        onClick={() => setActiveSection(0)}
                      >
                        {" "}
                        <h2>By Disease</h2>
                      </div>
                      <div
                        className={`tab ${
                          activeSection === 1 ? "selected" : ""
                        }`}
                        onClick={() => setActiveSection(1)}
                      >
                        <h2>By Formula</h2>
                      </div>
                      <div
                        className={`tab ${
                          activeSection === 2 ? "selected" : ""
                        }`}
                        onClick={() => setActiveSection(2)}
                      >
                        <h2>Custom Formulas</h2>
                      </div>

                      {/* <div
                        className={`tab ${
                          activeSection === 3 ? "selected" : ""
                        }`}
                        onClick={() => setActiveSection(3)}
                      >
                        <h2>Favorite Formulas</h2>
                      </div> */}
                      <div
                        className={`tab ${
                          activeSection === 4 ? "selected" : ""
                        }`}
                        onClick={() => setActiveSection(4)}
                      >
                        <h2>By Patented Formula</h2>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="detail-wrapper">
                      {activeSection === 0 && (
                        <SearchByDiseaseList
                          isRawType={isRawType}
                          closePopup={closePopup}
                          includeDosage={includeDosage}
                          setIncludeDosage={setIncludeDosage}
                        />
                      )}
                      {activeSection === 1 && (
                        <SearchByFormulaList
                          isRawType={isRawType}
                          closePopup={closePopup}
                          includeDosage={includeDosage}
                          setIncludeDosage={setIncludeDosage}
                          fromCustomFormula={fromCustomFormula}
                        />
                      )}
                      {activeSection === 2 && (
                        <CustomFormulaList
                          isRawType={isRawType}
                          closePopup={closePopup}
                          includeDosage={true}
                          setIncludeDosage={setIncludeDosage}
                        />
                      )}
                      {activeSection === 3 && (
                        <FavoriteFormulaList
                          isRawType={isRawType}
                          closePopup={closePopup}
                          includeDosage={includeDosage}
                          setIncludeDosage={setIncludeDosage}
                        />
                      )}
                      {activeSection === 4 && (
                        <SearchByPatendedFormula
                          isRawType={isRawType}
                          closePopup={closePopup}
                          includeDosage={includeDosage}
                          setIncludeDosage={setIncludeDosage}
                          fromCustomFormula={fromCustomFormula}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default FormulaFinderPopup;
